import styled from 'styled-components';

export const PurchaseOptions = styled.div`
  display: flex;
  width: 27%;
  flex-direction: column;
`;

export const SubscriptionContainer = styled.div<{ isSelected: boolean }>`
  margin-bottom: 30px;
  font-size: 0.92rem;
  background-color: white;
  padding: 20px 25px;
  border-radius: 5px;
  border: ${({ theme, isSelected }) =>
    `1px solid ${isSelected ? theme.palette.primary : 'white'}`};
  &:hover {
    border: ${({ theme }) => `1px solid ${theme.palette.primaryHover}`};
  }
  cursor: pointer;
`;

export const QuantityWrapper = styled.div`
  > div:nth-child(1) {
    padding-top: 10px;
    padding-bottom: 10px;
    color: rgba(0, 0, 0, 0.63);
  }
`;

export const ButtonWrapper = styled.div`
  padding-top: 10px;
  width: 100%;
`;

export const BasePrice = styled.div`
  font-size: 1.4rem;
  line-height: 36px;
  color: rgba(0, 0, 0, 0.63);
  font-weight: 500;
  padding-top: 10px;
`;

export const Separator = styled.div`
  border-bottom: 3px solid rgba(0, 0, 0, 0.09);
  width: 60px;
  padding-top: 10px;
`;

export const OptionDetails = styled.div`
  margin-left: 28px;
`;

export const SubscriptionDiscountMessage = styled.div`
  font-size: 0.9rem;
  color: rgba(0, 0, 0, 0.63);
  margin-top: 5px;
  line-height: 25px;
  > span {
    color: ${({ theme }) => theme.palette.primary};
    cursor: pointer;
    font-weight: 600;
  }
`;
